<script lang="ts" setup>
import { KirbyStudentPreviewData } from "@/queries/student"
</script>

<template>
  <div class="grid grid-cols-1 xl:grid-cols-3 md:grid-cols-2 gap-8">
    <slot />
  </div>
</template>
